module.exports = __webpack_public_path__ + "img/info-icon.d54c3ede.svg";